import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'

import { Form, Input ,Select } from 'antd';
import {ButtonBase} from '@mui/material';
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
const { Option } = Select;

export default function CreatUser() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [form] = Form.useForm();


  const onFinish = async ({username: uname,phNum: ph,password: psw,fullName: fname,maxDailyLimit}) => {
    setLoading(true)
    const img = `https://ui-avatars.com/api/background/?background=000&color=fff&size=128&rounded=true&name=${uname}`
    if(!fname) fname = '';
    if(!ph) ph = '';
    const params ={uname,ph,psw,fname,maxDailyLimit}

    const data = await axios.post(`/member/createMember`,params)

    let msgObj = { code: data.code, msg: data.message }
    if(data.code == 200){
      msgObj.msg = "Successfully created member account"
      form.resetFields();
    } 
    setErrorMsg(msgObj)
    setLoading(false)
    setOpenAlert(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
 
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        padding: 1rem;
        margin: 0 10rem;
      `}
    >
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        form={form}
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper form={form}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Save</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = ({form}) =>{
  const [agentName,setAgentName] = useState()

  useEffect(()=>{
    const shareName = localStorage.getItem("shareName");
    setAgentName(shareName)
  })
  const handleUsernameChange = (e) =>{
    form.setFieldsValue({
      username: e.currentTarget.value.toUpperCase().replace(/ /g, '')
    });
  }
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >

        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="username"
          hasFeedback
          rules={[
            {
              required: true,
              message: `Please input username!`,
            },
          ]}
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  addonBefore={agentName} size="large" color='rgb(248, 250, 252)' onChange={handleUsernameChange}/>
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Full Name"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="fullName"
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              required: true,
              message: `Please input full name!`,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number (optional)"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input 
          type='number'
          onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
          size="large"
           />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          style={{ padding: "0 0.4rem", color: "white" }}
          hasFeedback
          // rules={[
          //   {
          //     required: true,
          //     message: "Please input password!",
          //   },
          //   {
          //     validator: validatePassword
          //   },
          // ]}
          rules={[
            {
              required: true,
              message: `Please input password!`,
            },
            {
              min: 6,
              max: 15,
              message: "Password must be between 5 and 13 words!",
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
         <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Max Daily Limit"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="maxDailyLimit"
          rules={[
            {
              required: true,
              message: `Please input max daily limit!`,
            }
          ]}
          initialValue={1000000}
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input size="large" />
        </Form.Item>
      </div>
    </div>
  );
}


